export const ROUTER_ROOT = "/";
export const ROUTER_TIMELINE = "/timeline";
export const ROUTER_USER_LOGIN = "/login";
export const ROUTER_USER_REGISTER = "/register";
export const ROUTER_USER_PASSWORD_REQUEST = "/password_request";
export const ROUTER_USER_PASSWORD_NEW = "/new_password";
export const ROUTER_USER_DELETE = "/delete_account";
export const ROUTER_MEMBERS = "/members";
export const ROUTER_MEMBERS_INVITE = "/members/invite";
export const ROUTER_MEMBERS_DELETE_RELATION = "/members/delete_relation";
export const ROUTER_IMAGE = "/image";
export const ROUTER_IMAGE_DETAIL = "/image/:imageHash";
export const ROUTER_MESSAGE = "/message";
export const ROUTER_MESSAGE_SENIOR = "/message/senior/:seniorHash";
export const ROUTER_MESSAGE_SENIOR_IMAGE = "/message/senior/:seniorHash/image";
export const ROUTER_VIDEO = "/video";
export const ROUTER_DOWNLOADS = "/downloads";
